import { useCallback } from 'react'
import { Handle, Position } from '@xyflow/react'
import armLogo from '@/assets/www.png'

function WebNode({ data, isConnectable }) {
  const onChange = useCallback((evt) => {}, [])

  return (
    <div className="custom-node-robots robots-limits">
      <div className="grid grid-cols-1">
        <div>
          <div></div>
          <div className="text-center">
            <img src={armLogo} alt="Web Logo" className="custom-node-robots-logo" />
          </div>
          <div className="text-center">
            <b>Web</b>
          </div>
        </div>
      </div>

      <Handle type="target" position={Position.Left} />
    </div>
  )
}

export default WebNode
